import { Link, useLocation } from 'wouter';
import { useAuth } from '../context/AuthContext';
import { CommandPalette } from './CommandPalette';
import { can } from '../lib/permissions';

export function Shell({ children }: { children: React.ReactNode }) {
  const { user, signOut } = useAuth();
  const [path] = useLocation();

  const nav = [
    { to: '/', label: 'Dashboard', perm: 'client.view' as const },
    { to: '/activity', label: 'Activity', perm: 'client.view' as const },
    { to: '/reports', label: 'Reports', perm: 'audit.read' as const, alt: 'export.run' as const },
    { to: '/audit', label: 'Audit', perm: 'audit.read' as const },
    { to: '/users', label: 'Users', perm: 'users.manage' as const },
    { to: '/admin/match-candidates', label: 'Duplicates', perm: 'users.manage' as const },
    { to: '/admin/unlinked-file-notes', label: 'Unlinked notes', perm: 'users.manage' as const },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <header className="qa-page-head px-6 lg:px-10 flex items-center justify-between gap-6">
        <div className="flex items-baseline gap-6">
          <Link to="/" className="flex items-baseline gap-2">
            <span className="qa-eyebrow">CLIENT—BASE</span>
            <span className="qa-display text-xl">cb<span className="qa-italic-accent">.ai</span></span>
          </Link>
          <nav className="hidden md:flex items-center gap-5 ml-4">
            {nav.map(n => {
              const ok = can(user?.role, n.perm) || (n.alt && can(user?.role, n.alt));
              if (!ok) return null;
              const active = path === n.to || (n.to !== '/' && path.startsWith(n.to));
              return (
                <Link key={n.to} to={n.to}
                  className={`text-sm font-medium ${active ? 'text-ink' : 'text-ink-mute hover:text-ink'} ${active ? 'border-b-2 border-rust pb-1' : ''}`}>
                  {n.label}
                </Link>
              );
            })}
          </nav>
        </div>
        <div className="flex items-center gap-3 text-sm">
          <span className="qa-mono text-xs text-ink-mute hidden sm:inline">{user?.email}</span>
          <span className="qa-badge qa-badge--brass">{user?.role}</span>
          <button onClick={signOut} className="btn-ghost text-sm">Sign out</button>
        </div>
      </header>
      <main className="flex-1 px-6 lg:px-10 py-6">{children}</main>
      <CommandPalette />
      <footer className="qa-hairline-t py-3 px-6 lg:px-10 text-xs text-ink-mute flex justify-between">
        <span>© {new Date().getFullYear()} Client-Base.ai — synthetic dev data, do not use for live client work</span>
        <span className="qa-mono">v0.1.0</span>
      </footer>
    </div>
  );
}
